import { createFileRoute } from '@tanstack/react-router';
import { RecordElectionOutcome } from '@/components/finance';

// ADR-076 (#630) — the owner / platform-admin control to record this campaign's election outcome.
// Under the Settings sub-nav; the tab is owner/admin-gated and the component self-gates, with the API
// as the durable gate (403 for anyone below the bar). Campaign-scoped (one campaign at a time).
export const Route = createFileRoute('/admin/finance/settings/election-outcome')({
  component: RecordElectionOutcome,
});
